"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _root_store = _interopRequireDefault(require("./root_store"));
var _api = _interopRequireDefault(require("./api"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var DownloadLinkStore = /*#__PURE__*/function (_RootStore) {
  function DownloadLinkStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, DownloadLinkStore);
    _this = _callSuper(this, DownloadLinkStore);
    _this.config = {
      deserialize: false,
      GET: {
        index: '/download_links'
      },
      POST: {
        upsert: '/download_links/upsert',
        upload: '/worksheets/:worksheetId/download_link_types/:downloadLinkTypeId/upload',
        composeText: '/worksheets/:worksheetId/download_link_types/:downloadLinkTypeId/compose_text',
        "import": '/worksheets/:worksheetId/download_link_types/:downloadLinkTypeId/import'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(DownloadLinkStore, _RootStore);
  return (0, _createClass2["default"])(DownloadLinkStore, [{
    key: "upsert",
    value: function upsert(params, callback) {
      this.api(params, callback, 'POST', 'upsert');
    }
  }, {
    key: "uploadPromise",
    value: function () {
      var _uploadPromise = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(worksheetId, downloadLinkTypeId, fileData) {
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return _api["default"].multipartPostPromise({
                url: "/api/worksheets/".concat(worksheetId, "/download_link_types/").concat(downloadLinkTypeId, "/upload"),
                data: {
                  data: fileData
                }
              });
            case 1:
              return _context.abrupt("return", _context.sent);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function uploadPromise(_x, _x2, _x3) {
        return _uploadPromise.apply(this, arguments);
      }
      return uploadPromise;
    }()
  }, {
    key: "importPromise",
    value: function () {
      var _importPromise = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(worksheetId, downloadLinkTypeId, url) {
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return this.apiPromise({
                data: {
                  url: url
                },
                ids: {
                  worksheetId: worksheetId,
                  downloadLinkTypeId: downloadLinkTypeId
                }
              }, 'POST', 'import');
            case 1:
              return _context2.abrupt("return", _context2.sent);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function importPromise(_x4, _x5, _x6) {
        return _importPromise.apply(this, arguments);
      }
      return importPromise;
    }()
  }, {
    key: "composeTextPromise",
    value: function () {
      var _composeTextPromise = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(worksheetId, downloadLinkTypeId, content) {
        return _regenerator["default"].wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return this.apiPromise({
                data: {
                  content: content
                },
                ids: {
                  worksheetId: worksheetId,
                  downloadLinkTypeId: downloadLinkTypeId
                }
              }, 'POST', 'composeText');
            case 1:
              return _context3.abrupt("return", _context3.sent);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function composeTextPromise(_x7, _x8, _x9) {
        return _composeTextPromise.apply(this, arguments);
      }
      return composeTextPromise;
    }()
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new DownloadLinkStore();